import { Component, OnInit, Input } from '@angular/core';
import { Breadcrumbs } from '@/shared/breadcrum/breadcrum.component';

@Component({
  selector: 'app-transaction-result-view',
  templateUrl: './transaction-result-view.component.html',
  styleUrls: ['./transaction-result-view.component.css'],
})
export class TransactionResultViewComponent implements OnInit {

  @Input() id: number = 0;
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() variant: 'success' | 'failure' = 'success';
  @Input() shouldShowFlow: boolean = false;
  @Input() breadcrums: Breadcrumbs = [];
  @Input() messageBold: string = '';
  @Input() message: string = '';
  @Input() actionButtonText: string = '';
  @Input() actionButtonPath: string = '';
  @Input() secondaryButtonText: string = '';
  @Input() secondaryButtonPath: string = '';
  @Input() actionButtonDescription: string = '';

  @Input() showButtonAction: boolean = true;
  @Input() classBackgroundWhiteActionButton: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }
}
